{
  "common.yes": {
    "text": "是",
    "sourceHash": "b3a43630",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.no": {
    "text": "否",
    "sourceHash": "61e6be1a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.related": {
    "text": "相关页面",
    "sourceHash": "6faf59d8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.relatedNav": {
    "text": "相关页面",
    "sourceHash": "6dc7db40",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.breadcrumb": {
    "text": "面包屑导航",
    "sourceHash": "30635f6c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "common.home": {
    "text": "首页",
    "sourceHash": "10b8c84e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "cite.title": {
    "text": "来源：{{label}}（核对于 {{date}}）",
    "sourceHash": "01792346",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.title": {
    "text": "新加坡 GST InvoiceNow 规定（IRAS）：指南与清单",
    "sourceHash": "5f393811",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.description": {
    "text": "用浅白语言介绍新加坡 GST InvoiceNow Requirement：五步清单、关键日期、免费软件与补助金，每项都出自 IRAS 和 IMDA。",
    "sourceHash": "2e5f836d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.crumb": {
    "text": "首页",
    "sourceHash": "52f50eae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.home.llms": {
    "text": "InvoiceNow 是什么、有什么好处、五步清单、即将举行的 IRAS 活动，以及可以向谁提问。",
    "sourceHash": "bb1cdd91",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.title": {
    "text": "如何在新加坡设置 GST InvoiceNow：5 个步骤",
    "sourceHash": "4bfb45a3",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.description": {
    "text": "新加坡 GST 注册企业的 InvoiceNow 设置步骤：确认您的日期、选择 InvoiceNow-Ready 软件、获取 Peppol ID、开启向 IRAS 提交的功能并进行测试。",
    "sourceHash": "fdf14cc2",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.crumb": {
    "text": "设置指南",
    "sourceHash": "f3664512",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.nav": {
    "text": "设置",
    "sourceHash": "0837a3d6",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.setup.llms": {
    "text": "为 GST InvoiceNow 规定做好准备的五个步骤，每一步都附有官方出处，另有 Peppol ID 查询，以及使用 InvoiceNow 时在哪里登录。",
    "sourceHash": "1c626952",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.title": {
    "text": "GST InvoiceNow 何时适用？阶段与日期计算器",
    "sourceHash": "09845b8b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.description": {
    "text": "GST InvoiceNow 从2025年11月1日至2031年4月1日的各阶段，以及按 IRAS 常见问题计算供应额、新注册企业和 GST 集团的日期计算器。",
    "sourceHash": "e161b889",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.crumb": {
    "text": "何时适用",
    "sourceHash": "f454ea0a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.nav": {
    "text": "何时适用",
    "sourceHash": "021e3a39",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.when.llms": {
    "text": "实施时间表和日期计算器的规则（IRAS 常见问题 Q1.5 至 Q1.12、Q7.2）。",
    "sourceHash": "ca1ed4d8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.title": {
    "text": "GST InvoiceNow 软件：免费配套、服务商与补助金",
    "sourceHash": "5fde6215",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.description": {
    "text": "免费的 InvoiceNow 配套；Xero、AutoCount、ABSS、SAP Business One、QuickBooks 等软件是否在 IMDA 的 InvoiceNow-Ready 名单上；以及如何找到服务商。",
    "sourceHash": "417bbf11",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.crumb": {
    "text": "软件与补助金",
    "sourceHash": "a862ba00",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.nav": {
    "text": "软件与补助金",
    "sourceHash": "a862ba00",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.free-software.llms": {
    "text": "免费配套、哪些常用会计软件在 IMDA 的 InvoiceNow-Ready 名单上、服务商名单，以及在免费配套、IRSP 和接入点之间做选择的小工具。",
    "sourceHash": "0f1212a3",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.title": {
    "text": "InvoiceNow 补助金：S$1,000 和 S$5,000 过渡补助金、Queen Bee",
    "sourceHash": "ad42ba17",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.description": {
    "text": "IMDA 的 GST InvoiceNow 过渡补助金（S$1,000 和 S$5,000）以及 S$25,000 的 Queen Bee 补助金：谁符合资格、条件、截止日期和申领表格，均注明 IMDA 出处。",
    "sourceHash": "90531b62",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.crumb": {
    "text": "补助金",
    "sourceHash": "8d86615a",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.nav": {
    "text": "补助金",
    "sourceHash": "8d86615a",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.grants.llms": {
    "text": "S$1,000 和 S$5,000 的 GST InvoiceNow 过渡补助金、S$25,000 的 Queen Bee 补助金及生产力解决方案补助金：资格、条件、期限和申领表格。",
    "sourceHash": "0baa9ee6",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.title": {
    "text": "GST InvoiceNow 如何运作：提交类型与 Peppol ID",
    "sourceHash": "0e07a929",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.description": {
    "text": "发票如何在 InvoiceNow 上传送并送达 IRAS（Type 1A、1B、2 和 3），什么是 Peppol ID、IRSP 和 Access Point，以及 Peppol ID 查询。",
    "sourceHash": "67b0d3a4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.crumb": {
    "text": "如何运作",
    "sourceHash": "d03ba450",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.nav": {
    "text": "如何运作",
    "sourceHash": "d03ba450",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.how-it-works.llms": {
    "text": "动画展示提交类型、您需要什么（Peppol ID、IRSP 或 Access Point），以及 Peppol ID 查询。",
    "sourceHash": "2dbc2e54",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.title": {
    "text": "POS 与零售的 GST InvoiceNow：销售数据与收据",
    "sourceHash": "e7b4858b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.description": {
    "text": "如果您通过 POS 或收银机销售，GST InvoiceNow Requirement 意味着什么：收据、汇总销售数据、不在 InvoiceNow 上的顾客，以及截止日期。",
    "sourceHash": "3d8df85c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.crumb": {
    "text": "POS 与零售",
    "sourceHash": "a1bea913",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.nav": {
    "text": "POS 与零售",
    "sourceHash": "343b7552",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.pos-and-retail.llms": {
    "text": "POS 与汇总销售（IRAS 常见问题 Q3.4、Q3.12）、不在 InvoiceNow 上的客户、截止日期和确认编号。",
    "sourceHash": "18167dca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.title": {
    "text": "GST InvoiceNow 常见问题：答案出自 IRAS",
    "sourceHash": "5ad6879b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.description": {
    "text": "关于新加坡 GST InvoiceNow Requirement 的简短解答，每句话都链接到其出处的 IRAS 常见问题或 e-Tax Guide 段落。",
    "sourceHash": "648fd67d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.crumb": {
    "text": "常见问题",
    "sourceHash": "3ed2943b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.nav": {
    "text": "常见问题",
    "sourceHash": "3ed2943b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.faq.llms": {
    "text": "所有常见问题的回答，每一句都有来源。",
    "sourceHash": "aac2b357",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.title": {
    "text": "GST InvoiceNow 链接：IRAS、IMDA、补助金、供应商名单",
    "sourceHash": "c174fb14",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.description": {
    "text": "所有 GST InvoiceNow 官方链接集中一处：IRAS e-Tax Guide 与常见问题、IMDA 补助金，以及解决方案供应商和 Access Point 名单，并逐一说明。",
    "sourceHash": "34db9b6c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.crumb": {
    "text": "实用链接",
    "sourceHash": "237d6316",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.nav": {
    "text": "链接",
    "sourceHash": "9202088e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.links.llms": {
    "text": "所有 IRAS 和 IMDA 官方链接，每项都有说明。",
    "sourceHash": "508112b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.title": {
    "text": "关于 InvoiceNow Hub：独立、非官方、有出处",
    "sourceHash": "50517565",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.description": {
    "text": "谁在运营 InvoiceNow Hub、网站为何存在、每项事实如何对照 IRAS 和 IMDA 来源核对，以及网站会储存哪些数据。",
    "sourceHash": "3ad6f2bf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.crumb": {
    "text": "关于本站",
    "sourceHash": "58e096de",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.about.llms": {
    "text": "谁在运营本站、事实如何核对，以及隐私。",
    "sourceHash": "90448af6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.title": {
    "text": "InvoiceNow Hub 更新记录：按日期列出内容变更",
    "sourceHash": "bab8730a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.description": {
    "text": "InvoiceNow Hub 所有内容变更的公开记录，按日期排列，包括对照 IRAS 和 IMDA 来源后作出的更正。",
    "sourceHash": "346f4996",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.crumb": {
    "text": "更新记录",
    "sourceHash": "b3dc8779",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.changelog.llms": {
    "text": "按日期列出的内容变更。",
    "sourceHash": "ff009ee8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.notfound.title": {
    "text": "找不到页面 · InvoiceNow Hub",
    "sourceHash": "2e79a110",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "meta.notfound.description": {
    "text": "此地址没有页面。",
    "sourceHash": "a05926c8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "banner.aria": {
    "text": "关于本站",
    "sourceHash": "5c9321fd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "banner.text": {
    "text": "<b>独立指南。</b>与 IRAS（新加坡税务局）或 IMDA（资讯通信媒体发展局）无关。涉及您本身情况的问题，请直接询问 <iras>IRAS</iras> 或 <imda>IMDA</imda>。",
    "sourceHash": "dd7d33bf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "banner.about": {
    "text": "关于本站",
    "sourceHash": "5c9321fd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.unofficial": {
    "text": "<b>非官方翻译。</b>以英文版本为准。",
    "sourceHash": "b9879782",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.englishLink": {
    "text": "阅读本页英文版",
    "sourceHash": "f26f93a5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.draft": {
    "text": "翻译草稿，尚未经母语人士审校。请勿依赖。",
    "sourceHash": "e7c07fff",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.switcher": {
    "text": "语言",
    "sourceHash": "9a73db9b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "i18n.current": {
    "text": "当前语言：{{language}}",
    "sourceHash": "1987a4ec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.main": {
    "text": "主菜单",
    "sourceHash": "51707928",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.footer": {
    "text": "页脚",
    "sourceHash": "575cffd2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.whatToDo": {
    "text": "我该怎么做？",
    "sourceHash": "0df3ccb7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.whatToDoShort": {
    "text": "该做什么",
    "sourceHash": "cf2e345d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.question": {
    "text": "我有问题",
    "sourceHash": "537be29b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.openMenu": {
    "text": "打开菜单",
    "sourceHash": "b79c01dc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.closeMenu": {
    "text": "关闭菜单",
    "sourceHash": "58ee52ce",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.overview": {
    "text": "概览",
    "sourceHash": "6a494fba",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "nav.privacy": {
    "text": "隐私",
    "sourceHash": "ebfa87e7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.disclaimer": {
    "text": "独立信息网站，与 IRAS 或 IMDA 无关。每项事实都链接到所依据的 IRAS 或 IMDA 文件；最近一次核对日期为 {{date}}。请始终以官方来源为准，涉及您本身情况的问题请咨询 <iras>IRAS</iras> 或 <imda>IMDA</imda>。",
    "sourceHash": "89524644",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.made": {
    "text": "在新加坡用 <heart>♥</heart> 制作",
    "sourceHash": "8fb48457",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.love": {
    "text": "爱心",
    "sourceHash": "d52792d1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "footer.updated": {
    "text": "最后更新 {{date}}",
    "sourceHash": "ef1dfe86",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.loading": {
    "text": "正在加载 InvoiceNow Hub",
    "sourceHash": "e69aca57",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.top": {
    "text": "独立指南",
    "sourceHash": "9f78118d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.place": {
    "text": "新加坡 · {{year}}",
    "sourceHash": "94ed3b21",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "welcome.tagline": {
    "text": "GST INVOICENOW REQUIREMENT，一站了解",
    "sourceHash": "0dc4b2b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.srTitle": {
    "text": "InvoiceNow：新加坡企业的 GST InvoiceNow Requirement，一站了解",
    "sourceHash": "17bc1a98",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.fig1": {
    "text": "图 01 — 新加坡企业直接互发电子发票",
    "sourceHash": "f160cfda",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.fig2": {
    "text": "图 02 — 电子发票把新加坡与区域和全球连接起来",
    "sourceHash": "5cb25fb0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.einvoice": {
    "text": "电子发票",
    "sourceHash": "59faa2c6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.inOnePlace": {
    "text": "一站了解",
    "sourceHash": "b01ebb29",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.lead": {
    "text": "GST InvoiceNow Requirement（消费税电子发票规定）是什么、何时适用于您的企业，以及下一步该做什么。",
    "sourceHash": "54df4707",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.lastVerified": {
    "text": "最近一次对照官方来源核对：{{date}}",
    "sourceHash": "fd6c7239",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.cta": {
    "text": "开始清单",
    "sourceHash": "f72c8cac",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "hero.mapAria": {
    "text": "动画地图：新加坡各地的企业以代表其行业的图标显示，互相发送电子发票。随后画面扩展为地球，显示新加坡与亚太地区相连。",
    "sourceHash": "4e099061",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.eyebrow": {
    "text": "01 — INVOICENOW 入门 101",
    "sourceHash": "7f5a8d73",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.title": {
    "text": "InvoiceNow<br/><accent>101</accent>",
    "sourceHash": "30bd8b9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.lead": {
    "text": "InvoiceNow 是新加坡的全国电子发票网络。从这里开始：它是什么、先做什么，以及去哪里看详情。",
    "sourceHash": "7c228434",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.today": {
    "text": "现在",
    "sourceHash": "25b07d1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.with": {
    "text": "使用 INVOICENOW",
    "sourceHash": "3ed59ed2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.supplier": {
    "text": "供应商",
    "sourceHash": "82872649",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.pdf": {
    "text": "PDF",
    "sourceHash": "ae047875",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.email": {
    "text": "电邮",
    "sourceHash": "4086f1a7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.retype": {
    "text": "重新输入",
    "sourceHash": "3ba5e258",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.customer": {
    "text": "客户",
    "sourceHash": "d03c4dd9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.network": {
    "text": "网络",
    "sourceHash": "60b0d865",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.node.iras": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.todayBody": {
    "text": "发票是 PDF 或纸质副本。客户读完后，再把数字重新输入到自己的系统里。",
    "sourceHash": "a82ec83b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "intro.withBody": {
    "text": "发票以结构化数据直接从供应商的软件送到客户的软件：没有 PDF，不用重新输入。对于已注册 GST 的企业，发票数据的副本也会发送给 IRAS。",
    "sourceHash": "6785c176",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.eyebrow": {
    "text": "查看详情",
    "sourceHash": "71c848a7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.when.text": {
    "text": "2025 至 2031 年的各个阶段，以及按照 IRAS 常见问题设计的日期计算器。",
    "sourceHash": "56c8cb0b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.free-software.text": {
    "text": "IMDA 的免费配套、InvoiceNow 补助金，以及如何找到供应商。",
    "sourceHash": "a5249cb4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.how-it-works.text": {
    "text": "发票和数据如何传送、Peppol ID 和 Access Point 是什么，以及您的下一步。",
    "sourceHash": "4dd8b32d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.pos-and-retail.text": {
    "text": "收据、汇总销售，以及不在 InvoiceNow 上的客户。",
    "sourceHash": "fb98cbca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.faq.text": {
    "text": "简短回答，每一句都链接到所依据的 IRAS 常见问题题号。",
    "sourceHash": "f92a335e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "explore.links.text": {
    "text": "所有 IRAS 和 IMDA 官方链接，每项都有说明。",
    "sourceHash": "508112b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.start": {
    "text": "从这里开始",
    "sourceHash": "3a69c0a3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.title": {
    "text": "现在该做什么",
    "sourceHash": "bd4b4b81",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.progress": {
    "text": "已完成 {{done}} / {{total}}",
    "sourceHash": "62cf8b88",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.reset": {
    "text": "重置清单",
    "sourceHash": "5eb00d60",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.guide": {
    "text": "完整的分步指南",
    "sourceHash": "766641cd",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.step": {
    "text": "第 {{n}} 步，共 {{total}} 步",
    "sourceHash": "291696c8",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.loginTitle": {
    "text": "InvoiceNow 有登录入口吗？",
    "sourceHash": "6b0d8733",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.loginLead": {
    "text": "您通过 InvoiceNow-Ready 解决方案使用 InvoiceNow，所以您登录的是服务商的软件，您的提交记录也显示在那里。",
    "sourceHash": "4bc71ba0",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.trackerNote": {
    "text": "想边做边勾选？",
    "sourceHash": "bbe04031",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "setup.trackerLink": {
    "text": "使用首页上的清单",
    "sourceHash": "a5cd9529",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.nextStep": {
    "text": "下一步 · 第 {{n}} 步，共 {{total}} 步",
    "sourceHash": "2d90689f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.allDone": {
    "text": "全部完成 🎉",
    "sourceHash": "8400e0dc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.iDidThis": {
    "text": "我已完成",
    "sourceHash": "22606b5a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.back": {
    "text": "返回清单",
    "sourceHash": "3eb56e0b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.done": {
    "text": "已完成 {{done}}/{{total}}",
    "sourceHash": "f158d5f0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.region": {
    "text": "清单快捷方式",
    "sourceHash": "ae6fc30b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.hide": {
    "text": "隐藏清单快捷方式",
    "sourceHash": "ec623fcd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.show": {
    "text": "显示清单快捷方式",
    "sourceHash": "157935ee",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.pill.showAria": {
    "text": "显示清单快捷方式，已完成 {{done}} / {{total}}",
    "sourceHash": "dfa0dd87",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.t": {
    "text": "查您的日期",
    "sourceHash": "5fa6b1aa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.d": {
    "text": "看看您属于哪个阶段。",
    "sourceHash": "98f79dae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.title": {
    "text": "查出您的日期",
    "sourceHash": "b817b897",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.body": {
    "text": "用计算器看看您属于哪个阶段。IRAS 应该也已通过 MyTaxMail（IRAS 网上信箱）通知您，请以那封信为准。",
    "sourceHash": "58e56ece",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.a.0": {
    "text": "打开日期计算器",
    "sourceHash": "c464a842",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.0.a.1": {
    "text": "查看完整时间表",
    "sourceHash": "b380042b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.t": {
    "text": "检查您的软件",
    "sourceHash": "9f42728f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.d": {
    "text": "它在 IMDA 的 InvoiceNow-Ready 名单上吗？还没有软件？选一个。",
    "sourceHash": "6f91043c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.title": {
    "text": "确认您的软件是 InvoiceNow-Ready",
    "sourceHash": "34412348",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.body": {
    "text": "在 IMDA 的 InvoiceNow-Ready 解决方案供应商（IRSP）名单上找您的软件。如果您使用自己的 ERP 或内部系统，就需要找一家获 IMDA 认证的 Access Point（接入点）供应商。还没有软件？IMDA 列出了免费配套。",
    "sourceHash": "752e3c18",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.0": {
    "text": "IRSP 名单",
    "sourceHash": "c2af4eb3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.1": {
    "text": "Access Point 名单",
    "sourceHash": "f269f97f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.2": {
    "text": "我没有 InvoiceNow-Ready 软件",
    "sourceHash": "fa95c4fe",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.3": {
    "text": "使用 POS 或零售系统？",
    "sourceHash": "02e235b8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.1.a.4": {
    "text": "帮我选择",
    "sourceHash": "7f98f8ed",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.t": {
    "text": "取得您的 Peppol ID",
    "sourceHash": "c53fe87f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.d": {
    "text": "联系您的 IRSP 或 Access Point 供应商。",
    "sourceHash": "2f4e24f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.title": {
    "text": "取得您的 Peppol ID",
    "sourceHash": "c53fe87f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.body": {
    "text": "请您的 IRSP 或 Access Point 供应商用您的 UEN（单一实体识别号码）在 SG Peppol Directory 为您的企业注册。在下方搜索，看看您是否已经有 Peppol ID。",
    "sourceHash": "9319d07f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.a.0": {
    "text": "请免费配套供应商回电",
    "sourceHash": "8b5a108e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.2.a.1": {
    "text": "开始前需要准备什么",
    "sourceHash": "3857a84c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.t": {
    "text": "启用 GST InvoiceNow 提交功能",
    "sourceHash": "235ac8d3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.d": {
    "text": "联系您的 IRSP 或 Access Point 供应商。",
    "sourceHash": "2f4e24f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.title": {
    "text": "启用 GST InvoiceNow 提交功能",
    "sourceHash": "235ac8d3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.body": {
    "text": "启用 GST InvoiceNow 提交功能，开始向 IRAS 提交发票数据。您的 IRSP 或 Access Point 供应商可以协助。",
    "sourceHash": "e83f15f8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.a.0": {
    "text": "向 IRAS 提交如何运作",
    "sourceHash": "a22b8b59",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.3.a.1": {
    "text": "阅读常见问题",
    "sourceHash": "7c14797e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.t": {
    "text": "确保提交成功",
    "sourceHash": "1c6ebe3f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.d": {
    "text": "发送测试发票，确认 IRAS 已收到。",
    "sourceHash": "90f2504f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.title": {
    "text": "确保提交成功",
    "sourceHash": "bfce8736",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.body": {
    "text": "在您的日期之前测试，并检查每次成功传送后，您的解决方案都显示 IRAS 确认编号（acknowledgement ID）。对于内部系统，IRAS 表示应预留 {{from}} 至 {{to}} 个月完成系统连接。",
    "sourceHash": "38d01780",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.a.0": {
    "text": "阅读 e-Tax Guide",
    "sourceHash": "e1863849",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.a.1": {
    "text": "参加 IRAS 网络研讨会",
    "sourceHash": "4e35f0a1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.step.4.a.2": {
    "text": "所有实用链接",
    "sourceHash": "7cd30ec6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.title": {
    "text": "您已准备好使用 InvoiceNow",
    "sourceHash": "53a66a01",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.body": {
    "text": "继续通过您的解决方案发送发票数据，并保存记录至少 5 年。查看您可能可以申请的补助金，并告诉您的贸易伙伴，他们可以向您发送电子发票。",
    "sourceHash": "ec58230d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.a.0": {
    "text": "可申请的补助金",
    "sourceHash": "56883285",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.a.1": {
    "text": "即将举行的活动",
    "sourceHash": "484376c0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "checklist.done.a.2": {
    "text": "我有问题",
    "sourceHash": "537be29b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.eyebrow": {
    "text": "02 — 即将举行的活动",
    "sourceHash": "05eca34c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.title": {
    "text": "<accent>现场</accent>学习",
    "sourceHash": "56984197",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.signup": {
    "text": "报名",
    "sourceHash": "6a7d7331",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.details": {
    "text": "详情",
    "sourceHash": "0ec24245",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.none": {
    "text": "目前没有开放报名的活动。<lnk>查看 IRAS 活动页面</lnk>",
    "sourceHash": "896a0649",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.source": {
    "text": "活动列表取自 <lnk>IRAS 活动页面</lnk>。报名的开放和截止由 IRAS 决定，请查看该页面了解最新情况。",
    "sourceHash": "b3c0894c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "events.asOf": {
    "text": "活动列表截至 {{date}}。",
    "sourceHash": "41c4773a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.eyebrow": {
    "text": "03 — 我有问题",
    "sourceHash": "7668c750",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.title": {
    "text": "向<accent>对的人</accent>提问",
    "sourceHash": "29b27cc1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.lead": {
    "text": "本站是独立网站，无法就您的情况提供意见。凡涉及您本身情况的问题，请使用下方 IRAS 和 IMDA 的官方联络表格。",
    "sourceHash": "a3135ddb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.allLinks": {
    "text": "查看所有实用链接",
    "sourceHash": "f90ceca2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "question.faq": {
    "text": "常见问题",
    "sourceHash": "97c33d95",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.setup.eyebrow": {
    "text": "设置指南",
    "sourceHash": "31e53132",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.setup.title": {
    "text": "五步设置 <accent>InvoiceNow</accent>",
    "sourceHash": "97d06ea2",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.setup.intro": {
    "text": "为 GST InvoiceNow 规定做好准备：确认您的实施日期，检查您的软件是否为 InvoiceNow-Ready（或选择免费配套），通过服务商获取 Peppol ID，开启 GST InvoiceNow 提交功能，并确认 IRAS 已确认收到您的发票数据。",
    "sourceHash": "7c1162fc",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.when.eyebrow": {
    "text": "何时适用",
    "sourceHash": "ddfdfa4a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.when.title": {
    "text": "GST InvoiceNow <accent>何时适用于您</accent>",
    "sourceHash": "4fe55c11",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.when.intro": {
    "text": "GST InvoiceNow Requirement 从 2025 到 2031 年分阶段实施。在时间表上找到您的阶段，或在计算器中回答几个问题。如果您已收到 IRAS 的 MyTaxMail 信件，请以信件为准。",
    "sourceHash": "3b4b34a1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.free-software.eyebrow": {
    "text": "软件与补助金",
    "sourceHash": "026adb00",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.free-software.title": {
    "text": "InvoiceNow 软件<accent>与补助金</accent>",
    "sourceHash": "c3422fc6",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.free-software.intro": {
    "text": "IMDA 为已注册 GST 的企业列出了免费的 InvoiceNow 配套，也提供补助金，用于订阅软件和连接您自己的系统。",
    "sourceHash": "c061b87b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.grants.eyebrow": {
    "text": "补助金",
    "sourceHash": "e51cbffa",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.grants.title": {
    "text": "InvoiceNow <accent>补助金</accent>",
    "sourceHash": "07424232",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.grants.intro": {
    "text": "IMDA 提供现金补助金，帮助企业加入 GST InvoiceNow：按企业规模划分的过渡补助金，以及连接自有 ERP 的更高额补助金。在订阅或开始项目之前，请先确认哪一项适合您：条件涉及您何时注册以及之前使用过什么。",
    "sourceHash": "062d6627",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.how-it-works.eyebrow": {
    "text": "如何运作",
    "sourceHash": "686e8db0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.how-it-works.title": {
    "text": "GST InvoiceNow <accent>如何运作</accent>",
    "sourceHash": "72d86e15",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.how-it-works.intro": {
    "text": "发票和数据如何在 InvoiceNow 上传送、参与需要什么，以及一个指引您下一步的简短检查工具。",
    "sourceHash": "c8b6e0d7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.pos-and-retail.eyebrow": {
    "text": "POS 与零售",
    "sourceHash": "69cfe073",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.pos-and-retail.title": {
    "text": "GST InvoiceNow：<accent>POS 与零售</accent>",
    "sourceHash": "93ab4774",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.pos-and-retail.intro": {
    "text": "如果您通过销售点系统（POS）或收银机向公众销售，以下是规定中对您最重要的部分。",
    "sourceHash": "c861edd4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.faq.eyebrow": {
    "text": "常见问题",
    "sourceHash": "3ed2943b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.faq.title": {
    "text": "GST InvoiceNow <accent>常见问题</accent>",
    "sourceHash": "0a7f8a21",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "head.faq.intro": {
    "text": "用浅白语言回答关于 GST InvoiceNow Requirement 的常见问题，逐句注明出处。",
    "sourceHash": "1fe05500",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.eyebrow": {
    "text": "时间表",
    "sourceHash": "bc44f6d6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.title": {
    "text": "谁加入、<accent>何时加入</accent>",
    "sourceHash": "9d560600",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.lead": {
    "text": "从 2025 到 2031 年分阶段实施。如果您已经注册了 GST，您的阶段取决于您的全年供应总额。",
    "sourceHash": "28b2be96",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.inEffect": {
    "text": "● 已生效",
    "sourceHash": "5d7236da",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.next": {
    "text": "○ 下一阶段 · {{until}}",
    "sourceHash": "1017e15a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.future": {
    "text": "○ {{until}}",
    "sourceHash": "21f6174a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.cta": {
    "text": "查您的实施日期",
    "sourceHash": "17b63db8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "timeline.source": {
    "text": "来源：<lnk>{{label}}</lnk>。门槛指截至 2025 年的会计期间内的全年供应总额。",
    "sourceHash": "b4b776f5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.inEffect": {
    "text": "已生效",
    "sourceHash": "208f4e47",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.underMonth": {
    "text": "不到一个月",
    "sourceHash": "53c8f61a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.oneMonth": {
    "text": "还有 1 个月",
    "sourceHash": "b8ad03cc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "until.months": {
    "text": "还有 {{count}} 个月",
    "sourceHash": "e7211b5b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.eyebrow": {
    "text": "计算器",
    "sourceHash": "b195868d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.title": {
    "text": "GST InvoiceNow 实施日期计算器",
    "sourceHash": "386f86e8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.mytaxmailLead": {
    "text": "请以 IRAS 的 MyTaxMail 信件为准。",
    "sourceHash": "80d5ce30",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.indicative": {
    "text": "本计算器仅供参考。IRAS 也发布了自己的<lnk>计算器电子表格</lnk>。",
    "sourceHash": "717145b9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q1": {
    "text": "1. 哪一项最符合您的企业？",
    "sourceHash": "a173820f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.existing": {
    "text": "已注册 GST",
    "sourceHash": "885dfae4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.voluntary": {
    "text": "正在自愿注册",
    "sourceHash": "72a133ab",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.compulsory": {
    "text": "正在强制注册",
    "sourceHash": "46f29b7e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.group": {
    "text": "属于消费税集团",
    "sourceHash": "4d8261d7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.excluded": {
    "text": "海外实体，或仅因反向征收而注册",
    "sourceHash": "29b09196",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kind.notRegistered": {
    "text": "未注册 GST",
    "sourceHash": "56e0842f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q1hint": {
    "text": "申请强制注册，但获批为自愿注册？请选这一项（IRAS 常见问题 Q1.6）。",
    "sourceHash": "17e96b52",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q2": {
    "text": "2. 您何时（或将何时）申请 GST 注册？",
    "sourceHash": "b41b4c75",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q2hint": {
    "text": "以申请日期为准，而不是批准日期（IRAS 常见问题 Q1.7）。",
    "sourceHash": "5ffa4140",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q3": {
    "text": "3. 公司是否在申请前 6 个月内成立？",
    "sourceHash": "cf03eefe",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.q4": {
    "text": "4. 公司是否从海外迁册到新加坡？",
    "sourceHash": "504df8b1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qReturns": {
    "text": "{{n}}. 您是否有截至 2025 年的会计期间的消费税申报表？",
    "sourceHash": "9b61dc20",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.returnsYes": {
    "text": "有，包括零申报",
    "sourceHash": "69f015cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qEnds": {
    "text": "您的会计期间在哪几个月结束？",
    "sourceHash": "a75ee2f9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.mar-jun-sep-dec": {
    "text": "3月、6月、9月、12月",
    "sourceHash": "898b4c44",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.jan-apr-jul-oct": {
    "text": "1月、4月、7月、10月",
    "sourceHash": "bbef00f0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.feb-may-aug-nov": {
    "text": "2月、5月、8月、11月",
    "sourceHash": "8158f7bd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ends.monthly": {
    "text": "每个月",
    "sourceHash": "cb5eaf92",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.mar-jun-sep-dec": {
    "text": "2025年1月至2025年12月",
    "sourceHash": "49706a77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.jan-apr-jul-oct": {
    "text": "2024年11月至2025年10月",
    "sourceHash": "c4fa8141",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.feb-may-aug-nov": {
    "text": "2024年12月至2025年11月",
    "sourceHash": "a48f9356",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.monthly": {
    "text": "2025年1月至2025年12月",
    "sourceHash": "49706a77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.suppliesFrom": {
    "text": "您在 {{window}} 期间的供应",
    "sourceHash": "26e2926d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.addUp": {
    "text": "把截至 2025 年的所有会计期间的申报表加起来（第 4 栏即为总额）。零申报算作 S$0。",
    "sourceHash": "0ace1072",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.sr": {
    "text": "标准税率（S$）",
    "sourceHash": "3aade13f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.zr": {
    "text": "零税率（S$）",
    "sourceHash": "6d230976",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ex": {
    "text": "免税（S$）",
    "sourceHash": "1f11d064",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qFull": {
    "text": "这些申报表是否涵盖完整的 12 个月？",
    "sourceHash": "b8a82dfa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.fullNo": {
    "text": "否，只涵盖部分时间",
    "sourceHash": "c1e50250",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.qDays": {
    "text": "涵盖多少天？",
    "sourceHash": "c417b49a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.daysPlaceholder": {
    "text": "例如 61",
    "sourceHash": "d3655bec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.empty": {
    "text": "回答问题即可看到您的阶段。您输入的内容不会离开您的浏览器。",
    "sourceHash": "cb154492",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.phase": {
    "text": "您的阶段 · {{until}}",
    "sourceHash": "da4b5e54",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.from-registration": {
    "text": "注册起即适用",
    "sourceHash": "3d0719b6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.iras-will-notify": {
    "text": "IRAS 会通知您",
    "sourceHash": "3ff33fc0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.follow-group": {
    "text": "跟随您的消费税集团",
    "sourceHash": "5f073b36",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.kicker.not-required": {
    "text": "无需遵守",
    "sourceHash": "37ffb4d7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.from-registration": {
    "text": "注册起",
    "sourceHash": "353e846a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.iras-will-notify": {
    "text": "IRAS 会告诉您",
    "sourceHash": "4b3e7862",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.follow-group": {
    "text": "您所在集团的日期",
    "sourceHash": "0a0ee677",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.date.not-required": {
    "text": "无需遵守",
    "sourceHash": "457ecb17",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.total": {
    "text": "全年供应总额",
    "sourceHash": "cde45247",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.equiv": {
    "text": "（折合 365 天）",
    "sourceHash": "a2f310c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.nextSteps": {
    "text": "查看我的下一步",
    "sourceHash": "388d4b07",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.ask": {
    "text": "就我的情况询问 IRAS",
    "sourceHash": "b149fe5e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.disclaimer": {
    "text": "仅供参考。以 IRAS MyTaxMail 通知上的日期为准。如果您属于共用 ERP 的特许经营或类似集团，且需要更多时间，IRAS 会逐一考虑延期申请（常见问题 Q1.14）。",
    "sourceHash": "6a570cea",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.count": {
    "text": "{{count}} 个问题，均注明出处",
    "sourceHash": "2601f760",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.lead": {
    "text": "简短回答。每一句都链接到所依据的官方文件，主要是 IRAS 的 <lnk>FAQ for businesses (23 Sep 2026)</lnk> 和 e-Tax Guide。",
    "sourceHash": "7c81d2ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.own": {
    "text": "涉及您本身企业的问题，请使用 <iras>IRAS 查询表格</iras>或 <imda>IMDA 联络表格</imda>。",
    "sourceHash": "858738e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.imda": {
    "text": "IMDA InvoiceNow 补助金",
    "sourceHash": "adb16488",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.infographic": {
    "text": "信息图",
    "sourceHash": "23e80f0b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.footnote": {
    "text": "补助金条款出自 <grants>{{grantsLabel}}</grants>。在订阅或开始项目之前，请向 IMDA 确认资格和条款。",
    "sourceHash": "c2d31e02",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.answerTitle": {
    "text": "InvoiceNow 有哪些补助金？",
    "sourceHash": "b8ff433f",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.faqLink": {
    "text": "IMDA 补助金常见问题",
    "sourceHash": "9ab3c874",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.faqHeading": {
    "text": "相关问题",
    "sourceHash": "2b9de2c5",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.heading": {
    "text": "免费配套",
    "sourceHash": "3c70769f",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.grantsTitle": {
    "text": "InvoiceNow 补助金",
    "sourceHash": "4b5a8bf7",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.grantsBody": {
    "text": "IMDA 过渡补助金和 Queen Bee 补助金，用于付费解决方案或连接自有 ERP。",
    "sourceHash": "84913ce3",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.grantsLink": {
    "text": "查看补助金",
    "sourceHash": "d8b3cd8e",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.checkTitle": {
    "text": "我的会计软件是 InvoiceNow-Ready 吗？",
    "sourceHash": "57c2b2d7",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.checkLead": {
    "text": "以下是常用软件在名单上的情况。名单经常更新，请以最新版本为准，并向您的服务商确认。",
    "sourceHash": "6f4f1b0b",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.colSoftware": {
    "text": "软件",
    "sourceHash": "c9f3f4b0",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.colStatus": {
    "text": "是否在 IMDA 名单上？",
    "sourceHash": "386c1714",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.listed.provider": {
    "text": "是，列于 <en>{{provider}}</en> 名下",
    "sourceHash": "23635794",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.listed.partners": {
    "text": "是，通过多家列出的实施合作伙伴",
    "sourceHash": "1b18849f",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.listed.no": {
    "text": "不在名单上",
    "sourceHash": "31e73b8c",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.notListed": {
    "text": "不在名单上？",
    "sourceHash": "4202fac9",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.footnote": {
    "text": "免费配套出自 <foc>{{focLabel}}</foc>。订阅前请向 IMDA 和服务商确认条款。",
    "sourceHash": "f13bab98",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.title": {
    "text": "寻找 InvoiceNow-Ready 解决方案供应商或 Access Point 供应商",
    "sourceHash": "0f89f1c0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.irsp": {
    "text": "InvoiceNow-Ready 解决方案供应商名单",
    "sourceHash": "3dd2d602",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.ap": {
    "text": "Access Point 名单",
    "sourceHash": "f269f97f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.foc": {
    "text": "免费（FOC）配套名单",
    "sourceHash": "ddc29fb7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.callback": {
    "text": "请免费配套供应商回电",
    "sourceHash": "8b5a108e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.allow": {
    "text": "预留",
    "sourceHash": "40a195d2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.months": {
    "text": "<from/>–<to/> 个月",
    "sourceHash": "2c742238",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.note": {
    "text": "完成内部企业系统与 IRAS 的连接，IRAS 如此表示",
    "sourceHash": "f8c89612",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "how.eyebrow": {
    "text": "发票如何传送",
    "sourceHash": "7e3a567e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "how.title": {
    "text": "发票<br/><accent>如何传送</accent>",
    "sourceHash": "1e14d5a4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "how.lead": {
    "text": "InvoiceNow 通过 Access Point（接入点）在企业之间发送发票，并把发票数据报给 IRAS。传送方式取决于您是发送方还是接收方，以及对方企业是否也在 InvoiceNow 上。",
    "sourceHash": "3e2cc109",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.eyebrow": {
    "text": "您需要什么",
    "sourceHash": "f56c0f90",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.peppolTitle": {
    "text": "一个 Peppol ID",
    "sourceHash": "e8ef1f25",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.peppolBody": {
    "text": "您的企业在 InvoiceNow 网络上的唯一地址。请您的 IRSP 或 Access Point 供应商用您的 UEN（单一实体识别号码）在 SG Peppol Directory 为您的企业注册。",
    "sourceHash": "c81f93ed",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.irspTitle": {
    "text": "一家 InvoiceNow-Ready 解决方案供应商（IRSP）或 Access Point（AP）",
    "sourceHash": "7a0d12d1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.irspBody": {
    "text": "IRSP 提供已通过认证 Access Point（接入点）连接网络的会计或财务软件。如果您使用自己的内部系统，就要通过获 IMDA 认证的 Access Point 供应商连接。",
    "sourceHash": "a97d60a9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "need.find": {
    "text": "寻找 IRSP 或 Access Point",
    "sourceHash": "d57d2f54",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.label": {
    "text": "按公司名称或 UEN 搜索",
    "sourceHash": "281e0185",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.placeholder": {
    "text": "公司名称或 UEN，例如 201538812W",
    "sourceHash": "43c52a01",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.aria": {
    "text": "公司名称或 UEN",
    "sourceHash": "f2805234",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.check": {
    "text": "查询 Peppol ID",
    "sourceHash": "6e66803a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.searching": {
    "text": "正在搜索…",
    "sourceHash": "2713de23",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.invalid": {
    "text": "请输入公司名称（至少 2 个字母）或 UEN。",
    "sourceHash": "cd611560",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.unreachable": {
    "text": "暂时无法连接 Peppol Directory，请稍后再试。",
    "sourceHash": "55d71974",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.found": {
    "text": "<b>找到：</b>{{name}} <id>{{peppolId}}</id>。下一步是确认它已连接到您打算使用的供应商。",
    "sourceHash": "0ee87f4c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.registered": {
    "text": "已注册",
    "sourceHash": "cdc6d0e1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.notFound": {
    "text": "Peppol Directory 中找不到。如果您还没有加入，这是正常的。您的 IRSP 或 Access Point 供应商会为您注册。<lnk>寻找供应商</lnk>",
    "sourceHash": "d932ee7a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.notFoundName": {
    "text": "找不到这个名称。请试试完整的注册名称或您的 UEN。还没有注册？您的 IRSP 或 Access Point 供应商会为您注册。<lnk>寻找供应商</lnk>",
    "sourceHash": "9b1ed20e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.matches": {
    "text": "Peppol Directory 中的结果：{{total}}。如果您的企业在列表中，就表示已有 Peppol ID。下一步是确认它已连接到您打算使用的供应商。",
    "sourceHash": "e1ddae9e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "peppol.more": {
    "text": "显示 {{total}} 个结果中的 {{shown}} 个。输入更完整的名称或您的 UEN 来缩小范围。",
    "sourceHash": "57697379",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.iAm": {
    "text": "我是…",
    "sourceHash": "cc41e59d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.supplier": {
    "text": "供应商，发送发票",
    "sourceHash": "0d5706bb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.customer": {
    "text": "客户，接收发票",
    "sourceHash": "95463d1f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.who": {
    "text": "谁在 INVOICENOW 上？",
    "sourceHash": "92863170",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.both": {
    "text": "我们双方",
    "sourceHash": "63fcdba9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.me": {
    "text": "只有我",
    "sourceHash": "d9d30f77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.lane.iras": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.lane.network": {
    "text": "INVOICENOW 网络",
    "sourceHash": "5c121afe",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.lane.businesses": {
    "text": "您的企业",
    "sourceHash": "76356c38",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.offline": {
    "text": "PDF · 电邮 · 纸质",
    "sourceHash": "11632b2b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.supplier": {
    "text": "供应商",
    "sourceHash": "b167f229",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.customer": {
    "text": "客户",
    "sourceHash": "09f3c039",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.iras": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.yours": {
    "text": "您的解决方案",
    "sourceHash": "cc62bba5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.node.theirs": {
    "text": "对方的解决方案",
    "sourceHash": "39bcf11e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.notOn": {
    "text": "不在 INVOICENOW 上",
    "sourceHash": "3afb6658",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.notNetwork": {
    "text": "不在网络上",
    "sourceHash": "5a6334b5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.tax": {
    "text": "税务机关",
    "sourceHash": "af6c504f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.sub.ap": {
    "text": "ACCESS POINT",
    "sourceHash": "59953bcd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.you": {
    "text": "您",
    "sourceHash": "956decfc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.play": {
    "text": "播放动画",
    "sourceHash": "874eb831",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.pause": {
    "text": "暂停动画",
    "sourceHash": "52d63d7f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.stepAria": {
    "text": "第 {{n}} 步：{{title}}",
    "sourceHash": "d1fceddf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.legend.invoice": {
    "text": "发票",
    "sourceHash": "cf85b330",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.legend.data": {
    "text": "副本给 IRAS",
    "sourceHash": "4bdb87b0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.legend.offline": {
    "text": "网络外的副本",
    "sourceHash": "7a61372e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.tag.parallel": {
    "text": "同时进行",
    "sourceHash": "a39f2315",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.tag.offNetwork": {
    "text": "网络外",
    "sourceHash": "29b6c97c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.toPartner": {
    "text": "发票 → 您的商业伙伴",
    "sourceHash": "a7f05d67",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.toIras": {
    "text": "发票数据 → IRAS",
    "sourceHash": "b82901d9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.headline": {
    "text": "您发送，而您的客户也在 InvoiceNow 上",
    "sourceHash": "54087a5e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.toBusiness": {
    "text": "通过 InvoiceNow 网络：您的 Access Point 把 Peppol 发票以结构化数据转发到客户的 Access Point。",
    "sourceHash": "c4869be7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.toIras": {
    "text": "Type 1A 提交：发票一送达客户的 Access Point，Peppol 发票的副本就会自动发送给 IRAS。您的客户随后提交他们自己的副本（Type 1B）。",
    "sourceHash": "2a8da6a8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.0.title": {
    "text": "开具",
    "sourceHash": "600895e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.0.text": {
    "text": "您在 InvoiceNow-Ready 解决方案中开具 Peppol 发票，并发送到您的 Access Point。具备 GST 验证检查的解决方案会在 GST 收错时提醒您。",
    "sourceHash": "e1466257",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.1.title": {
    "text": "发送并抄送 IRAS",
    "sourceHash": "ce947cc3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.1.text": {
    "text": "您的 Access Point 把发票转发到客户的 Access Point。发送后，Peppol 发票的副本会自动发送给 IRAS。",
    "sourceHash": "1cbd8bb4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.2.title": {
    "text": "送达",
    "sourceHash": "4955b9ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.2.text": {
    "text": "客户的 Access Point 把发票转交给您的客户。",
    "sourceHash": "feb817ca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.3.title": {
    "text": "客户也提交",
    "sourceHash": "0dc2f06c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.both.3.text": {
    "text": "您的客户在自己的解决方案中接受发票，并记录 GST 采购资料。他们的 Access Point 把这笔采购的 Solution-extracted 副本发送给 IRAS。",
    "sourceHash": "11484894",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.headline": {
    "text": "您发送，但您的客户不在 InvoiceNow 上",
    "sourceHash": "76ea01b7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.toBusiness": {
    "text": "在网络外：您像现在一样，给客户纸质或 PDF 发票。",
    "sourceHash": "b3e17818",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.toIras": {
    "text": "Type 2 提交：您的解决方案提取发票，由您的 Access Point 发送给 IRAS。汇总的供应，例如 POS 销售或简化税务发票，也是这样处理。",
    "sourceHash": "6490082d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.0.title": {
    "text": "开具并记录",
    "sourceHash": "e9ec0b9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.0.text": {
    "text": "您给客户纸质或 PDF 发票，并在 InvoiceNow-Ready 解决方案中记录这笔销售。它不会经过网络。",
    "sourceHash": "f0271b4a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.1.title": {
    "text": "提取并报告",
    "sourceHash": "abfdc6cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.supplier.me.1.text": {
    "text": "您的解决方案把 Solution-extracted 发票提交到您的 Access Point，再由它传送给 IRAS。",
    "sourceHash": "03c42d61",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.headline": {
    "text": "您接收，而您的供应商也在 InvoiceNow 上",
    "sourceHash": "f5fe09d5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.toBusiness": {
    "text": "通过 InvoiceNow 网络：供应商的 Access Point 把 Peppol 发票以结构化数据转发到您的 Access Point。",
    "sourceHash": "d7e9df9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.toIras": {
    "text": "Type 1B 提交：您接受发票后，这笔采购的 Solution-extracted 副本会通过您的 Access Point 发送给 IRAS。供应商的 Peppol 副本（Type 1A）另行发送。",
    "sourceHash": "b3a58971",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.0.title": {
    "text": "开具",
    "sourceHash": "600895e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.0.text": {
    "text": "您的供应商在其 InvoiceNow-Ready 解决方案中开具 Peppol 发票。",
    "sourceHash": "c8d431ad",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.1.title": {
    "text": "发送",
    "sourceHash": "f28e14cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.1.text": {
    "text": "对方的 Access Point 把发票转发到您的 Access Point。发送后，Peppol 发票的副本由对方发送给 IRAS。",
    "sourceHash": "cda781be",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.2.title": {
    "text": "接收",
    "sourceHash": "2e823442",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.2.text": {
    "text": "您的 Access Point 以数据形式把发票转交给您，不用重新输入。",
    "sourceHash": "32aaf536",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.3.title": {
    "text": "接受并报告",
    "sourceHash": "242bc2b6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.both.3.text": {
    "text": "您在解决方案中核实并接受发票，选择 GST 类别、采购金额和要申报的进项税。Solution-extracted 副本会通过您的 Access Point 发送给 IRAS。",
    "sourceHash": "06b6a288",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.headline": {
    "text": "您接收，但您的供应商不在 InvoiceNow 上",
    "sourceHash": "6cbebde0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.toBusiness": {
    "text": "在网络外：发票像现在一样以 PDF 或纸质形式送到您手上。",
    "sourceHash": "58c597f9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.toIras": {
    "text": "Type 3 提交：您的解决方案提取这笔采购，由您的 Access Point 发送给 IRAS。汇总的采购，例如零用现金，也是这样处理。",
    "sourceHash": "8de06b13",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.0.title": {
    "text": "接收",
    "sourceHash": "2e823442",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.0.text": {
    "text": "您的供应商给您纸质或 PDF 发票。它不会经过网络。",
    "sourceHash": "2391b008",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.1.title": {
    "text": "记录",
    "sourceHash": "9f4565ec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.1.text": {
    "text": "您在 InvoiceNow-Ready 解决方案中记录这笔采购。具备 GST 验证检查的解决方案会在 GST 收错时提醒您。",
    "sourceHash": "97271995",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.2.title": {
    "text": "提取并报告",
    "sourceHash": "abfdc6cf",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "flow.s.customer.me.2.text": {
    "text": "您的解决方案把 Solution-extracted 发票发送到您的 Access Point，再由它传送给 IRAS。",
    "sourceHash": "739a8ecb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.eyebrow": {
    "text": "帮我选择",
    "sourceHash": "6024c28d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.title": {
    "text": "哪个选项适合我？",
    "sourceHash": "5ee3747e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.q3": {
    "text": "1. 您开出和收到多少张发票？",
    "sourceHash": "e86275b7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.low": {
    "text": "少",
    "sourceHash": "b1dd9521",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.lowSub": {
    "text": "每月几张",
    "sourceHash": "581a6e39",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.medium": {
    "text": "中等",
    "sourceHash": "09be5f96",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.mediumSub": {
    "text": "每月几十张",
    "sourceHash": "a096dc27",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.high": {
    "text": "多",
    "sourceHash": "be0a061d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.vol.highSub": {
    "text": "数百张或更多",
    "sourceHash": "2ec41bc2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.q4": {
    "text": "2. 您目前用什么开发票？",
    "sourceHash": "3c5f9fa5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.manual": {
    "text": "手动",
    "sourceHash": "f819f303",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.manualSub": {
    "text": "Word、Excel、PDF",
    "sourceHash": "b775770f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.software": {
    "text": "会计软件",
    "sourceHash": "5e9c3af1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.softwareSub": {
    "text": "现成的软件",
    "sourceHash": "fa76f995",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.custom": {
    "text": "ERP 或内部系统",
    "sourceHash": "670dde48",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.tool.customSub": {
    "text": "定制或整合的系统",
    "sourceHash": "4263e83c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.empty": {
    "text": "回答两个问题，我们会建议您先考虑哪种解决方案。",
    "sourceHash": "30e1ee9e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.disclaimer": {
    "text": "仅供一般参考。在作出决定前，请向 IMDA、IRAS 和供应商确认资格、价格和供应情况。",
    "sourceHash": "d6a0edc2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.route.kicker": {
    "text": "推荐途径",
    "sourceHash": "ffe36e89",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.name": {
    "text": "免费（FOC）解决方案",
    "sourceHash": "361ea5f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.what": {
    "text": "IMDA 为已注册 GST 的企业列出了免费的 InvoiceNow 配套。它们可能适合发票不多、目前用电子表格、Word 或 PDF 开发票的企业。",
    "sourceHash": "31792265",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.0": {
    "text": "从 IMDA 的免费配套名单中选一个配套。各供应商的开始和结束日期不同，请查看您所选配套的日期。",
    "sourceHash": "0330ed6e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.1": {
    "text": "注册后，通过供应商注册您的 Peppol ID（以 UEN 为基础的识别码）。",
    "sourceHash": "0a9e08c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.FOC.2": {
    "text": "在您的开始日期之前发送测试发票，确认数据已送达 IRAS。",
    "sourceHash": "cc0a2a77",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.name": {
    "text": "InvoiceNow-Ready 解决方案供应商（IRSP）",
    "sourceHash": "8503d344",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.what": {
    "text": "内置 Access Point 连接的会计或发票软件，让发票和向 IRAS 提交数据都在您已在用的工具中完成。",
    "sourceHash": "158cc89a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.0": {
    "text": "查看 IMDA 的 InvoiceNow-Ready 解决方案供应商名单。如果您现在的软件在名单上，请询问厂商如何启用 InvoiceNow。",
    "sourceHash": "8f638a12",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.1": {
    "text": "如果不在，挑选一家符合您发票数量和预算的名单内供应商。",
    "sourceHash": "c256493e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.IRSP.2": {
    "text": "请供应商注册您的 Peppol ID，然后在开始日期之前测试发送。",
    "sourceHash": "b2ccef6b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.name": {
    "text": "Peppol Access Point（AP）供应商",
    "sourceHash": "c8495985",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.what": {
    "text": "把您自己的系统（ERP 或内部系统）连接到网络的供应商。最适合发票由您控制的软件产生，或发票量很大的情况。",
    "sourceHash": "1263b849",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.0": {
    "text": "列出产生和接收发票的系统，以及由谁维护整合。",
    "sourceHash": "be87739d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.1": {
    "text": "从 IMDA 的 Access Point 供应商名单中挑选，并确认他们支持您系统的导出格式。",
    "sourceHash": "f461faa6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.rec.AP.2": {
    "text": "通过 Access Point 注册您的 Peppol ID，然后进行端到端测试，包括向 IRAS 提交数据。",
    "sourceHash": "016ac0c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.iras": {
    "text": "IRAS 规定页面",
    "sourceHash": "1068e5ec",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.foc": {
    "text": "免费配套名单",
    "sourceHash": "9ee3fb61",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.ap": {
    "text": "Access Point 名单",
    "sourceHash": "f269f97f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "next.link.irsp": {
    "text": "IRSP 名单",
    "sourceHash": "c2af4eb3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.eyebrow": {
    "text": "实用链接",
    "sourceHash": "e36a7c96",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.title": {
    "text": "每个链接，<accent>都有说明</accent>",
    "sourceHash": "401b26c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.eyebrow": {
    "text": "关于本站",
    "sourceHash": "4475af1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.title": {
    "text": "独立、<accent>非官方</accent>、有出处",
    "sourceHash": "3a1f5b49",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.who.title": {
    "text": "谁在运营本站",
    "sourceHash": "c75f38fc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.who.body": {
    "text": "InvoiceNow Hub 是一个独立网站。它不由新加坡税务局（IRAS）或资讯通信媒体发展局（IMDA）运营、认可，也与它们无关。",
    "sourceHash": "6d510d85",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.why.title": {
    "text": "本站为何存在",
    "sourceHash": "9f7701ba",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.why.body": {
    "text": "关于 GST InvoiceNow Requirement 的官方信息分散在多个 IRAS 和 IMDA 网页及 PDF 中。本站把它们集中在一处，用浅白语言说明，并把每一句话都链接回所依据的官方文件。",
    "sourceHash": "e283fb73",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.unofficial.title": {
    "text": "本站是非官方的",
    "sourceHash": "efb0b4c6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.unofficial.body": {
    "text": "本站内容不是法律或税务意见，也不能取代 IRAS 通过 MyTaxMail 发给您的实施日期。如果本站内容与 IRAS 或 IMDA 不同，以官方来源为准。",
    "sourceHash": "83ce30b0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.unofficial.channels": {
    "text": "凡涉及您本身企业的问题，请使用官方渠道：<iras>IRAS GST InvoiceNow queries form</iras> 或 <imda>IMDA InvoiceNow contact form</imda>。",
    "sourceHash": "e46d2c5c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.translations.title": {
    "text": "翻译",
    "sourceHash": "5901bcad",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.translations.body": {
    "text": "中文、马来文和泰米尔文版本是英文内容的非官方翻译，以英文版本为准。尚未经母语人士审校的翻译会在每页顶部标明为草稿；如果英文内容有更改，在翻译更新之前将显示英文。",
    "sourceHash": "6c37be80",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.title": {
    "text": "内容如何核对",
    "sourceHash": "10eb8ce1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.body": {
    "text": "每个日期、门槛、金额、常见问题回答和链接都存放在同一个数据文件里，并附上官方来源的网址、确切的题号或段落编号，以及最近一次核对的日期。网页、给搜索引擎的常见问题数据和<txt>纯文本版本</txt>都由这个文件生成，因此不会互相矛盾。自动检查会确认每个来源链接仍然有效，并标出过去 30 天内未重新核对的内容。",
    "sourceHash": "94cb7fe2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.last": {
    "text": "内容最近一次对照官方来源核对的日期是 <b>{{date}}</b>。本站只依据以下来源：",
    "sourceHash": "9cbd5c33",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.checked": {
    "text": "核对于 {{date}}",
    "sourceHash": "c8a58a32",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.check.changelog": {
    "text": "每一项内容变更都连同日期列在<lnk>更新记录</lnk>中。",
    "sourceHash": "5fa09f15",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.title": {
    "text": "隐私",
    "sourceHash": "ebfa87e7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.lead": {
    "text": "本站不会要求您提供姓名、电邮或任何账户。本站自身的代码不加载任何广告脚本。",
    "sourceHash": "6e9962e9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.checklist": {
    "text": "<b>清单：</b>“现在该做什么”会把您勾选了几步（一个数字）保存在浏览器的本地存储中，下次来访时仍在。它不会离开您的设备。使用“重置清单”或清除本站数据即可删除。",
    "sourceHash": "05dc1042",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.display": {
    "text": "<b>显示设置：</b>您是否看过开场动画、是否关闭了清单快捷方式，会保存在会话存储中，关闭标签页时浏览器会清除。",
    "sourceHash": "a8983f5e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.language": {
    "text": "<b>语言：</b>如果您用语言切换器选择语言，一个小小的 cookie 会记住您的选择，网站就不会再为您跳转。它只包含语言代码。",
    "sourceHash": "c1e811cb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.calc": {
    "text": "<b>日期计算器和“哪个选项适合我？”：</b>完全在您的浏览器中运行，不储存任何内容。",
    "sourceHash": "20c08d6b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.peppol": {
    "text": "<b>Peppol ID 查询：</b>您输入的公司名称或 UEN 会发送到公开的 Peppol Directory（directory.peppol.eu）进行搜索。不会发送其他内容，本站代码也不会储存它。",
    "sourceHash": "69907a85",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.fonts": {
    "text": "<b>字体：</b>由本站提供，而不是来自第三方。",
    "sourceHash": "14122bb3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "about.privacy.analytics": {
    "text": "<b>分析：</b>我们的托管商 Cloudflare 目前启用了 Cloudflare Web Analytics。它会加载来自 static.cloudflareinsights.com 的脚本，把页面浏览数据发送给 Cloudflare。这不是本站代码的一部分；如果它被关闭，我们会更新这段说明。",
    "sourceHash": "b75fb1d9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "changelog.eyebrow": {
    "text": "更新记录",
    "sourceHash": "8628b339",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "changelog.title": {
    "text": "改了什么、<accent>何时改的</accent>",
    "sourceHash": "8357f12f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "changelog.lead": {
    "text": "本站所有内容变更，最新的排在前面。事实都对照<lnk>关于本站</lnk>页面列出的 IRAS 和 IMDA 官方来源核对。",
    "sourceHash": "9335307d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.title": {
    "text": "找不到<accent>页面</accent>",
    "sourceHash": "abb2b9fa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.body": {
    "text": "此地址没有页面。网站拆分成多个主题页面时，它可能已经移动。",
    "sourceHash": "1786edf3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.home": {
    "text": "前往首页",
    "sourceHash": "6fe7cf79",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "notfound.links": {
    "text": "实用链接",
    "sourceHash": "237d6316",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  }
}
